module.exports = "#map {\n  width: 100%;\n  height: 100%;\n}"